import { createIcon } from '@chakra-ui/icons'
import React from 'react'
export const IconFile = createIcon({
  displayName: 'IconFile',
  path: [
    <path
      key="0"
      d="M20 22H4V2H11V4H6V20H18V9H13V2H15.41L20 6.59V22ZM15 7H17.59L15 4.41V7Z"
      fill="currentColor"
    />,
  ],
  viewBox: '0 0 24 24',
})
